export class RavenApiSettings {
    username: string;
    password: string;
}
